// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2oslo","validationTips":"StatementDescriptor_validationTips__37BrS"};